import Home from '../pages/Home';
import ArtPortfolio from '../pages/Art-Portfolio';
import Downloads from '../pages/Downloads';
import FourCornerstones from '../pages/Four-Cornerstones';
import LetterToShareholders from '../pages/Letter-to-Shareholders';
import Q1LetterToShareholders from '../pages/Letter-to-Shareholders-q1';
import Q2LetterToShareholders from '../pages/Letter-to-Shareholders-q2';
import Q3LetterToShareholders from '../pages/Letter-to-Shareholders-q3';
import ObjectivesPolicies from '../pages/Objectives-Policies';
import Q1ObjectivesPolicies from 'pages/Objectives-Policies-q1';
import Q2ObjectivesPolicies from '../pages/Objectives-Policies-q2';
import Q3ObjectivesPolicies from '../pages/Objectives-Policies-q3';
import OperationsSummary from '../pages/Operations-Summary';
import Q1OperationsSummary from '../pages/Operations-Summary-q1';
import Q2OperationsSummary from '../pages/Operations-Summary-q2';
import Q3OperationsSummary from '../pages/Operations-Summary-q3';
import ShareholderInformation from '../pages/Shareholder-Information';
import FinancialHighlights from '../pages/Financial-Highlights';

// Import images
import homeMasthead from '../assets/images/content/Connell_2002_The_Space_Between.jpg';
import financialHighlightsMasthead from '../assets/images/Financial-Highlights.jpg';
import fourCornerstonesMasthead from '../assets/images/Four-Cornerstones.jpg';
import letterToShareholdersMasthead from '../assets/images/Objectives-Policies.jpg';
import operationsSummaryMasthead from '../assets/images/Operations-Summary.jpg';
import objectivesPoliciesMasthead from '../assets/images/content/Corridor_Two_9x12_300.jpg';
import shareholderInformationMasthead from '../assets/images/Shareholder-Information.jpg';
import downloadsMasthead from '../assets/images/content/Connell_2010_Next_Door.jpg';
import artPortfolioMasthead from '../assets/images/content/Connell_2015_Lakeside.jpg';

export const routes = [
	{
		// Home
		path: '/',
		component: Home,
		name: 'Empathy',
		exact: true,
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#767727',
		type: 'home',
		masthead: {
			image: homeMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-center',
		},
		clipPaths: [
			{
				initial: { x: '0%', y: '0%', width: '100%', height: '100%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
		isExpanded: true,
	},
	{
		// Financial Highlights
		path: '/financial-highlights',
		component: FinancialHighlights,
		name: 'Financial Highlights',
		showInNav: true,
		toggleColor: '#C9B815',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#767727',
		type: 'fin-highlight',
		masthead: {
			image: financialHighlightsMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-center items-start',
		},
		clipPaths: [
			{
				initial: { x: '9%', y: '20%', width: '28%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '72%', y: '22%', width: '16%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Four Cornerstones
		path: '/four-cornerstones',
		component: FourCornerstones,
		name: 'Four Cornerstones',
		showInNav: true,
		toggleColor: '#F26721',
		toggleActiveColor: '#F26721',
		fullNavColor: '#4B7B9D',
		type: 'four-cornerstones',
		masthead: {
			image: fourCornerstonesMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-start items-center',
		},
		clipPaths: [
			{
				initial: { x: '61%', y: '3%', width: '43%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Letter to Shareholders
		path: '/letter-to-shareholders',
		component: LetterToShareholders,
		name: 'Letter to Shareholders',
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#F05860',
		type: 'letter',
		label: 'Archive: 2024 Annual Report',
		masthead: {
			image: letterToShareholdersMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-start items-end',
		},
		clipPaths: [
			{
				initial: { x: '12%', y: '5%', width: '22%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '44%', y: '32%', width: '10%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Letter to Shareholders
		path: '/letter-to-shareholders/first-quarter',
		component: Q1LetterToShareholders,
		name: 'Letter to Shareholders',
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#F05860',
		type: 'letter',
		label: 'Archive: 2025 First Quarter',
		masthead: {
			image: letterToShareholdersMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-start items-end',
		},
		clipPaths: [
			{
				initial: { x: '12%', y: '5%', width: '22%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '44%', y: '32%', width: '10%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Letter to Shareholders Q2
		path: '/letter-to-shareholders/second-quarter',
		component: Q2LetterToShareholders,
		name: 'Letter to Shareholders',
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#F05860',
		type: 'letter',
		label: 'Archive: 2025 Second Quarter',
		masthead: {
			image: letterToShareholdersMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-start items-end',
		},
		clipPaths: [
			{
				initial: { x: '12%', y: '5%', width: '22%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '44%', y: '32%', width: '10%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Letter to Shareholders Q3
		path: '/letter-to-shareholders/third-quarter',
		component: Q3LetterToShareholders,
		name: 'Letter to Shareholders',
		showInNav: true,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#F05860',
		type: 'letter',
		label: 'Current: 2025 Third Quarter',
		masthead: {
			image: letterToShareholdersMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-start items-end',
		},
		clipPaths: [
			{
				initial: { x: '12%', y: '5%', width: '22%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '44%', y: '32%', width: '10%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Operations Summary
		path: '/operations-summary',
		component: OperationsSummary,
		name: 'Operations Summary',
		showInNav: false,
		toggleColor: '#FCB94C',
		toggleActiveColor: '#FCB94C',
		fullNavColor: '#E79C22',
		type: 'operations',
		label: 'Archive: 2024 Annual Report',
		masthead: {
			image: operationsSummaryMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1980,
				height: 1528,
			},
			titleAlignment: 'place-items-end items-center lg:mt-[140px]',
		},
		clipPaths: [
			{
				initial: { x: '0%', y: '0%', width: '28%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '55%', y: '23%', width: '20%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Operations Summary
		path: '/operations-summary/first-quarter',
		component: Q1OperationsSummary,
		name: 'Operations Summary',
		showInNav: false,
		toggleColor: '#FCB94C',
		toggleActiveColor: '#FCB94C',
		fullNavColor: '#E79C22',
		type: 'operations',
		label: 'Archive: 2025 First Quarter',
		masthead: {
			image: operationsSummaryMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1980,
				height: 1528,
			},
			titleAlignment: 'place-items-end items-center lg:mt-[140px]',
		},
		clipPaths: [
			{
				initial: { x: '0%', y: '0%', width: '28%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '55%', y: '23%', width: '20%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Operations Summary Q2
		path: '/operations-summary/second-quarter',
		component: Q2OperationsSummary,
		name: 'Operations Summary',
		showInNav: false,
		toggleColor: '#FCB94C',
		toggleActiveColor: '#FCB94C',
		fullNavColor: '#E79C22',
		type: 'operations',
		label: 'Archive: 2025 Second Quarter',
		masthead: {
			image: operationsSummaryMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1980,
				height: 1528,
			},
			titleAlignment: 'place-items-end items-center lg:mt-[140px]',
		},
		clipPaths: [
			{
				initial: { x: '0%', y: '0%', width: '28%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '55%', y: '23%', width: '20%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Operations Summary Q3
		path: '/operations-summary/third-quarter',
		component: Q3OperationsSummary,
		name: 'Operations Summary',
		showInNav: true,
		toggleColor: '#FCB94C',
		toggleActiveColor: '#FCB94C',
		fullNavColor: '#E79C22',
		type: 'operations',
		label: 'Current: 2025 Third Quarter',
		masthead: {
			image: operationsSummaryMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1980,
				height: 1528,
			},
			titleAlignment: 'place-items-end items-center lg:mt-[140px]',
		},
		clipPaths: [
			{
				initial: { x: '0%', y: '0%', width: '28%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
			{
				initial: { x: '55%', y: '23%', width: '20%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Objectives & Policies
		path: '/objectives-policies',
		component: ObjectivesPolicies,
		name: 'Objectives and Policies',
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#767727',
		type: 'objectives',
		label: 'Archive: 2024 Annual Report',
		masthead: {
			image: objectivesPoliciesMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1728,
				height: 1296,
			},
			titleAlignment: 'place-items-end items-end',
		},
		clipPaths: [
			{
				initial: { x: '8%', y: '16%', width: '30%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Objectives & Policies
		path: '/objectives-policies/first-quarter',
		component: Q1ObjectivesPolicies,
		name: 'Objectives and Policies',
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#767727',
		type: 'objectives',
		label: 'Archive: 2025 First Quarter',
		masthead: {
			image: objectivesPoliciesMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1728,
				height: 1296,
			},
			titleAlignment: 'place-items-end items-end',
		},
		clipPaths: [
			{
				initial: { x: '8%', y: '16%', width: '30%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Objectives & Policies Q2
		path: '/objectives-policies/second-quarter',
		component: Q2ObjectivesPolicies,
		name: 'Objectives and Policies',
		showInNav: false,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#767727',
		type: 'objectives',
		label: 'Archive: 2025 Second Quarter',
		masthead: {
			image: objectivesPoliciesMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1728,
				height: 1296,
			},
			titleAlignment: 'place-items-end items-end',
		},
		clipPaths: [
			{
				initial: { x: '8%', y: '16%', width: '30%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Objectives & Policies Q3
		path: '/objectives-policies/third-quarter',
		component: Q3ObjectivesPolicies,
		name: 'Objectives and Policies',
		showInNav: true,
		toggleColor: '#A3CBC0',
		toggleActiveColor: '#A3CBC0',
		fullNavColor: '#767727',
		type: 'objectives',
		label: 'Current: 2025 Third Quarter',
		masthead: {
			image: objectivesPoliciesMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1728,
				height: 1296,
			},
			titleAlignment: 'place-items-end items-end',
		},
		clipPaths: [
			{
				initial: { x: '8%', y: '16%', width: '30%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		// Shareholder Information
		path: '/shareholder-information',
		component: ShareholderInformation,
		name: 'Shareholder Information',
		showInNav: true,
		toggleColor: '#767727',
		toggleActiveColor: '#767727',
		fullNavColor: '#4B7B9D',
		type: 'shareholder-information',
		masthead: {
			image: shareholderInformationMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-center',
		},
		clipPaths: [
			{
				initial: { x: '60%', y: '30%', width: '38%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		path: '/downloads',
		component: Downloads,
		name: 'Financial Downloads',
		showInNav: true,
		toggleColor: '#767727',
		toggleActiveColor: '#767727',
		fullNavColor: '#F05860',
		masthead: {
			image: downloadsMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-end items-end',
		},
		clipPaths: [
			{
				initial: { x: '19%', y: '23%', width: '44%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
	{
		path: '/art-portfolio',
		component: ArtPortfolio,
		name: 'Art Portfolio',
		showInNav: true,
		toggleColor: '#FCB94C',
		toggleActiveColor: '#FCB94C',
		fullNavColor: '#E79C22',
		masthead: {
			image: artPortfolioMasthead,
			alt: 'PROG-2023-AR-Cover',
			dimensions: {
				width: 1920,
				height: 1440,
			},
			titleAlignment: 'place-items-end items-end',
		},
		clipPaths: [
			{
				initial: { x: '30%', y: '16%', width: '48%' },
				expanded: { x: '0%', y: '0%', width: '100%', height: '100%' },
			},
		],
	},
];
